/** eslint-disable max-len */
import type {
  Entitlements,
  JobPostingUpgradeEntitlement,
} from '../../reducers/entitlement/entitlement'
import type { ProductConfig } from '../../reducers'
import type { Jobs } from '../../reducers/jobs/jobs'

export const FETCH : 'entitlement/FETCH' = 'entitlement/FETCH'
export const SET: 'entitlement/SET' = 'entitlement/SET'
export const FETCH_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFICATION: 'entitlement/FETCH_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFICATION' = 'entitlement/FETCH_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFICATION'
export const SET_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFCATION: 'entitlement/SET_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFCATION' = 'entitlement/SET_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFCATION'

export type FetchEntitlementsAction = {
  type: typeof FETCH,
  payload: undefined,
}

export type SetEntitlementsAction = {
  payload: Entitlements,
  type: typeof SET,
}

export type FetchUpgradeCreditsForProductSpecificationAction = {
  type: typeof FETCH_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFICATION,
  payload: ProductConfig,
}

export type SetUpgradeCreditsForProductSpecificationAction = {
  type: typeof SET_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFCATION,
  payload: {
    productSpecification: ProductConfig,
    entitlements: Array<JobPostingUpgradeEntitlement>,
  },
}

export type EntitlementsActions =
  | FetchEntitlementsAction
  | FetchUpgradeCreditsForProductSpecificationAction
  | SetEntitlementsAction
  | SetUpgradeCreditsForProductSpecificationAction

export const fetchEntitlements = (): FetchEntitlementsAction => ({
  type: FETCH,
  payload: undefined,
})

export const setEntitlements = (entitlements: Entitlements): SetEntitlementsAction => ({
  payload: entitlements,
  type: SET,
})

export const fetchUpgradeCreditsForProductSpecification = (
  productSpecification: ProductConfig,
): FetchUpgradeCreditsForProductSpecificationAction => ({
  type: FETCH_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFICATION,
  payload: productSpecification,
})

export const setUpgradeCreditsForProductSpecification = (
  productSpecification: ProductConfig,
  entitlements: Array<JobPostingUpgradeEntitlement>,
): SetUpgradeCreditsForProductSpecificationAction => ({
  payload: {
    productSpecification,
    entitlements,
  },
  type: SET_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFCATION,
})
